<template>
  <div class="container" v-if="vacancy">

    <video-container
      v-if="vacancyVideo && !fromRegistration"
      :vacancyVideo="vacancyVideo"
    />

    <div class="greet">
      <h1>{{ vacancyName }}</h1>

      <p>
        {{ $tr('videoInterview.start.greetings.hello') }} {{ userName }}!
        <br>
        <template v-if="isVCVai">
          {{ $tr('videoInterview.start.greetings.letsStart') }}
        </template>
        <template v-else-if="vacancyName">
          {{ $tr('videoInterview.start.greetings.gladToGreet') }}
          <br class="mobile-hide"/>
          {{ $tr('videoInterview.start.greetings.gladToGreet2') + this.companyName + '!' }}
        </template>
        <template v-else>
          {{ $tr('videoInterview.start.greetings.gladToGreetCompany') }}
        </template>
      </p>
    </div>


    <div class="download-app" v-if="isMobile.any">
      <p> {{ $tr('videoInterview.start.content.mobile.downloadApp') }} </p>

      <a v-if="isMobile.android.device" href="https://play.google.com/store/apps/details?id=ru.letsee.vcv">
        <img v-if="currentLocale === 'ru'" src="/static/images/elements/ru_google_play.png" alt="Доступно в Google Play">
        <img v-else-if="currentLocale === 'en'" src="/static/images/elements/en_google_play.png" alt="Avaliable on Google Play">
      </a>

      <a v-else-if="isMobile.apple.device" href="https://itunes.apple.com/ru/app/vcv-запись-видеоинтервью/id694977644?mt=8">
        <img v-if="currentLocale === 'ru'" src="/static/images/elements/ru_app_store.svg" alt="Загрузите в App Store">
        <img v-else-if="currentLocale === 'en'" src="/static/images/elements/en_app_store.svg" alt="Download on the App Store">
      </a>
    </div>


    <div class="step">
      <h1>
        <i class='fa fa-video-camera vid-int-start__icon'></i>
        {{ $tr('videoInterview.start.content.title') }}
      </h1>


      <template v-if="!isMobile.any">
        <p>
          {{ $tr('videoInterview.start.content.desktop.text') }}
          <b>{{ $tr('videoInterview.start.content.desktop.camera') }}</b>
          {{ $tr('videoInterview.start.content.desktop.and') }}
          <b>{{ $tr('videoInterview.start.content.desktop.micro') }}</b>.
          <br />
          {{ $tr('videoInterview.start.content.desktop.text2') }}
        </p>

        <p class="browsers">
          <br />
          {{ $tr('videoInterview.start.content.desktop.supported') }}
          <template v-if="currentLocale === 'ru'">
            <a href="https://www.google.ru/chrome/index.html">{{ $tr('videoInterview.start.content.desktop.browser1') }}</a>,
            <a href="https://www.mozilla.org/ru/firefox/new/">{{ $tr('videoInterview.start.content.desktop.browser2') }}</a>,
            <a href="https://browser.yandex.ru/">{{ $tr('videoInterview.start.content.desktop.browser3') }}</a>
          </template>
          <template v-else-if="currentLocale === 'en'">
            <a href="https://www.google.com/chrome/index.html">{{ $tr('videoInterview.start.content.desktop.browser1') }}</a>,
            <a href="https://www.mozilla.org/en/firefox/new/">{{ $tr('videoInterview.start.content.desktop.browser2') }}</a>
          </template>
        </p>
      </template>

      <template v-else>
        <template v-if="isVCVai">
          <p>
            In order to complete your interview, you need to record your answers to questions that will be offered to you, using your computer with
            <b>camera</b>
            and
            <b>microphone</b>.
            <br />
            We'd recommend that you do it in your spare time and in a quiet and comfortable place as video interview might take from 10 to 40 minutes.
          </p>
        </template>
        <template v-else>
          <p>
            {{ $tr('videoInterview.start.content.mobile.text') }}
            <b>{{ $tr('videoInterview.start.content.mobile.camera') }}</b>
            {{ $tr('videoInterview.start.content.mobile.and') }}
            <b>{{ $tr('videoInterview.start.content.mobile.micro') }}</b>.
            <br />
            {{ $tr('videoInterview.start.content.mobile.text2') }}
          </p>
        </template>
      </template>


      <div v-if="!disable && !is_disable_record_videointerview && vacancy.is_active">
        <div class="column-checkbox">
          <div class="flex_center">
            <vcheckbox v-model="check" class="margin_right"/>
            <span class="agreement-description" v-html="$tr('vacancy.openRegistration.personalDataAgreement', {
              agreement_link: agreement_link,
              user_agreement_link: user_agreement_link,
              privacy_link: privacy_link,
              cookies_link: cookies_link
            })"></span>
          </div>
        </div>

        <div class="column-checkbox">
          <div class="flex_center">
            <vcheckbox v-model="checkVideo" class="margin_right"/>
            <span class="agreement-description" v-html="$tr('videoInterview.checkVideo.termsVideo')"></span>
          </div>
        </div>
      </div>
    </div>

    <p class="forbidden" v-if="vacancy.is_active === false">
      {{ $tr('videoInterview.start.archived') }}
    </p>

    <vbutton
      v-else-if="!disable && !is_disable_record_videointerview"
      label="videoInterview.start.button"
      :disabled="!submitButtonEnabled"
      @click="startInterview" />

    <p class="forbidden" v-else>
      {{ $tr('videoInterview.start.forbidden') }}
    </p>

    <div
      v-if="vacancyDescription && !fromRegistration"
      class="description__content description"
      v-html="vacancyDescription"
    >
    </div>
  </div>
</template>

<script>
import isMobile from 'ismobilejs'
import VideoContainer from './StartVideoContainer';
import vcheckbox from '@/components_new/vcheckbox/index';

export default {
  name: 'interview-start',

  components: {
    VideoContainer,
    vcheckbox
  },

  props: {
    companyName: String,
    userName: String,
    vacancyName: String,
    vacancyDescription: String,
    vacancyVideo: String,
    token: String,
    fromRegistration: Boolean,
    disable: Boolean
  },

  data () {
    return {
      isMobile: isMobile,
      check: false,
      checkVideo: false
    }
  },

  computed: {
    // isNewWay () {
    //   return this.$store.getters['services/isNewWay'];
    // },
    vacancy() {
      return this.$store.getters['interview/vacancy'];
    },

    agreement_link() {
      return 'https://vcv.' + this.current_domain + '/pages/agreement/';
    },

    user_agreement_link() {
      return 'https://vcv.' + this.current_domain + '/pages/user-agreement/';
    },

    privacy_link() {
      return 'https://vcv.' + this.current_domain + '/pages/privacy-policy/';
    },

    cookies_link() {
      switch (this.current_domain) {
        case 'en':
          return 'https://vcv.ai/pages/cookies-terms';
        case 'ru':
          return 'https://vcv.ru/pages/cookies-terms-ru';
        case 'ja':
          return 'https://vcv.ai/pages/cookies-terms';
        default:
          return 'https://vcv.ai/pages/cookies-terms';
      }
    },

    is_disable_record_videointerview () {
      return this.vacancy.is_disable_record_videointerview
    },

    urlDomainZone () {
      const a = document.createElement('a')
      a.href = window.location.origin

      return a.hostname ? a.hostname.split('.').pop() : ''
    },

    isVCVai () {
      return this.urlDomainZone === 'ai'
    },

    linkToVideointerview () {
      return `vcv-video://interview/?token=${this.token}&host=${window.location.host}`
    },

    currentLocale () {
      return this.$store.state.locale.value
    },

    current_domain() {
      return this.$store.getters['services/current_domain'] || 'ru'
    },

    submitButtonEnabled () {
      return this.check && this.checkVideo
      /* const checkbox = this.fields ? this.fields.accept : null
      const required = checkbox ? checkbox.required : false

      return required ? checkbox.valid : true */
    }
  },

  created() {
    this.set_current_domain()
  },

  beforeDestroy() {
    this.$store.commit('services/clear');
  },

  methods: {
    startInterview() {
      if (isMobile.phone || isMobile.tablet) {
        window.location = this.linkToVideointerview;
      } else {
        this.$emit('agreed');
      }
    },

    set_current_domain() {
      this.$store.commit('services/set_current_domain')
    }
  }
};
</script>

<style lang="scss" scoped>
@import '../../styles/colors.scss';
.margin_right {
  margin-right: 10px;
}
.accept_label {
  min-width: 20px;
  margin-right: 10px;
}
.flex_center {
  display: flex;
  align-items: center;
}
.container {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;

  h1, p, span { margin: 0; }

  .greet,
  .download-app,
  .step,
  .description {
    width: 100%;
  }

  .greet {
    text-align: center;
    margin-bottom: 40px;
    max-width: 100%;

    h1 {
      font-weight: 500;
      line-height: normal;
      font-size: 28px;
      margin-bottom: 36px;
      max-width: 100%;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    p {
      font-size: 16px;
      line-height: 1.5em;
    }
  }


  .download-app {
    text-align: center;
    margin-bottom: 40px;

    img {
      height: 40px;
    }

    p {
      line-height: 1.5em;
      font-size: 16px;
      margin-bottom: 20px;
    }
  }


  .step {
    text-align: left;
    margin-bottom: 40px;
    max-width: 100%;

    h1 {
      font-size: 22px;
      color: #3EAF29;
      margin-bottom: 20px;
      font-weight: normal;

      i { margin-right: 5px; }
    }

    p {
      font-size: 16px;
      line-height: 1.5em;

      b { font-weight: 500; }

      &.vcv-ai { color: $error-color; }
    }

    .browsers a { color: #3EAF29; }

    .column-checkbox {
      display: flex;
      margin-top: 33px;

      span {
        width: calc(100% - 20px);

        span {
          margin-left: 0;
        }
      }
    }
  }
  input[type="checkbox"] + label {
    min-width: 20px;
  }
  input[type="checkbox"] + label + span a {
    text-decoration: none;
  }

  p.forbidden {
    color: $error-color;
    margin-bottom: 50px;
  }

  .vcv-button {
    min-width: 180px;
    margin-bottom: 50px;
  }

  .description {
    margin-bottom: 80px;
  }

}

@media (max-width: 768px) {
  .container {
    .mobile-hide {
      display: none;
    }

    .step {
      .column-checkbox {
        display: flex;
      }

      .column-checkbox span { margin-left: 9px; }
    }
  }
}
</style>
